type Props = {
  title: string | undefined | null;
  hasBreadcrumbs: boolean;
};

export const NarrativeCommunityDefaultHeader = ({
  title,
  hasBreadcrumbs,
}: Props) => {
  return (
    <div className="mt-2">
      {hasBreadcrumbs && (
        <h1 className="m-0 mb-1 text-xl font-bold [word-break:break-word]">
          {title}
        </h1>
      )}
      <p className="text-soft">
        Our community narratives are driven by numbers and valuation.
      </p>
    </div>
  );
};
